/**
 * Created by evgenijsenkevic on 27.08.2024
 * */

const AdminLocationsView = cc.Node.extend({
    ctor: function (model) {
        this._super();
        this.model = model;

        const size = cleverapps.resolution.getSceneSize();
        const styles = cleverapps.styles.AdminLocationsView;
        this.setContentSize(styles.width, size.height - styles.paddingY);

        this.createBg();
        this.createContent();
        this.setAlignment(styles.position);
    },

    createBg: function () {
        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.common_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setAnchorPoint(0.5, 0.5);
        bg.setContentSize2(this.getContentSize());
        bg.setAlignment(this.width / 2, this.height / 2);
        this.addChild(bg);
    },

    createContent: function () {
        const label = cleverapps.UI.generateOnlyText("Locations", cleverapps.styles.FONTS.ADMIN_LEVEL_TEXT);

        const contentViews = [label];
        this.model.adminLocations.forEach((location) => {
            contentViews.push(new AdminLocationView(location));
        });

        const styles = cleverapps.styles.AdminLocationsView;

        const layout = new cleverapps.Layout(contentViews, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        const scrollView = this.scrollView = new cleverapps.UI.ScrollView(layout, {
            childrenVisibility: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL,
            scrollBarEnabled: false
        });

        this.scrollView.setContentSize2(styles.content);
        scrollView.scrollToDefault();
        scrollView.setAlignment(styles.content);

        this.addChild(scrollView);
    }
});

cleverapps.styles.AdminLocationsView = {
    width: 220,
    paddingY: 100,

    margin: 10,

    position: {
        x: { align: "left" },
        y: { align: "center" }
    },

    content: {
        x: { align: "center" },
        y: { align: "top", dy: -40 },
        width: 220,
        height: 1180
    }
};